import { createContext } from 'react';

// AI-CONTEXT: See docs/features/livereport-widgets-dashboard-parity.md
// The bare React Context for the live-report editor — extracted so
// consumers (e.g. NestedItemControl in the sidebar) can import the
// context without pulling in the Provider's widget registry chain.
// EditorContext.jsx imports + re-exports this for back-compat.

/**
 * @typedef {import('./EditorContext').EditorContextValue} EditorContextValue
 */

/** @type {React.Context<EditorContextValue|null>} */
export const EditorContext = createContext(/** @type {EditorContextValue|null} */ (null));
